<template>
  <div
    class="quick-view-list"
    v-bind:class="{ show: item }"
    data-epica-module-name="Contenido Lista"
    data-mrf-recirculation="Contenido Lista"
  >
    <div class="grid-y content-quick-view" v-if="item">
      <div class="header-quick-view">
        <div class="ctrlsList d-flex">
          <button
            type="button"
            v-bind:class="{ h: p }"
            class="arrow-list"
            @click="prev"
          >
            <i class="icon-arrow_back"></i>
          </button>
          <button
            type="button"
            v-bind:class="{ h: n }"
            class="arrow-list"
            @click="next"
          >
            <i class="icon-arrow_forward"></i>
          </button>
          <div class="grow"></div>
          <div class="flex-grow-1"></div>
          <button type="button" class="close-button" @click="close">
            <i class="icon-close"></i>
          </button>
        </div>
      </div>
      <div class="col auto">
        <img :src="item.image.url" :alt="item.image.alt" />
        <h3 class="kicker" v-html="item.header"></h3>
        <h2 v-html="item.title"></h2>
        <div v-html="item.content"></div>
      </div>
      <div class="content-button" v-if="item.url">
        <a :href="item.url" class="bt">VER MÁS CONTENIDO</a>
      </div>
    </div>
    <div
      class="opacity-menu"
      @click="close"
      v-bind:class="{ show: item }"
    ></div>
  </div>
</template>

<script>
import epica from "./../../../features/epica";
export default {
  props: {
    idx: Number,
  },
  watch: {
    idx: function (newVal, preVal) {
      this.selectedIdx = this.idx;
    },
  },
  data: function () {
    return {
      selectedIdx: -1,
      p: false,
      n: false,
    };
  },
  created: function () {
    this.items = window.postList;
    document.addEventListener("keyup", this.keyup);
  },
  updated: function () {
    epica();
  },
  computed: {
    item: function () {
      const ret = this.selectedIdx > -1 ? this.items[this.selectedIdx] : null;
      if (ret) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
      return ret;
    },
  },
  methods: {
    openItem: function (idx) {
      this.$emit("changed", idx);
    },
    close: function () {
      this.$emit("changed", -1);
    },
    keyup: function (event) {
      if (event.isComposing || event.keyCode === 229) {
        return;
      }
      if (this.item) {
        if (event.keyCode == 37) {
          this.p = true;
          setTimeout(() => {
            this.p = false;
          }, 100);
          this.prev();
        }
        if (event.keyCode == 39) {
          this.n = true;
          setTimeout(() => {
            this.n = false;
          }, 100);
          this.next();
        }
        if (event.keyCode == 27) {
          this.close();
        }
      } else {
        if (event.keyCode == 71 && event.altKey) {
          this.openItem(0);
        }
      }
    },
    next: function () {
      if (this.items.length > this.selectedIdx + 1) {
        this.$emit("changed", this.selectedIdx + 1);
      } else {
        this.$emit("changed", 0);
      }
    },
    prev: function () {
      if (this.selectedIdx - 1 < 0) {
        this.$emit("changed", this.items.length - 1);
      } else {
        this.$emit("changed", this.selectedIdx - 1);
      }
    },
  },
};
</script>
